<template>
  <DynamicComponents :components="components" />
</template>
<script setup>
import DynamicComponents from "@apexl/icarus-core/src/components/partials/DynamicComponents.vue";

const props = defineProps({
  components: {
    type: Array,
    required: true,
  },
});
</script>
